module.exports = __webpack_public_path__ + "static/media/S2EC.ee0f57ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S2EC.jpg
// module id = 89
// module chunks = 0